import { useQuery } from "@tanstack/react-query";

import RegionService from "services/Regions";

export function useRegionOptions() {
  const { data: regionOptions = [] } = useQuery({
    queryKey: ["region-options"],
    queryFn: async () => {
      const regions = await RegionService.getRegions();
      return regions.map(({ id, name }) => ({
        key: id,
        value: id,
        text: name,
      }));
    },
  });

  return regionOptions;
}
